export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f7cec99c3ffbac58e3c863667f2a9e93bca4c5008&name=fetchTypeahead!'